"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlazeInvalidArgException = void 0;
class BlazeInvalidArgException extends Error {
    constructor(code, message) {
        super(message);
        this.name = 'BlazeInvalidArgException';
        this.code = code;
    }
}
exports.BlazeInvalidArgException = BlazeInvalidArgException;
//# sourceMappingURL=BlazeInvalidArgException.js.map